import {
  CheckCircleIcon,
  ChevronLeftIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getBulkUserInvites } from '../../../../../api/Terminal/UserAccount';
import { IGetBulkUserInvitesResData } from '../../../../../api/Terminal/UserAccount/types';
import { formatDate3 } from '../../../../../utils';
import Button from '../../../../UI/Button';
import BulkUserInviteSummary from './BulkUserInviteSummary';

interface IBulkUserInviteHistoryProps {
  handleModal: (modalName: 'inviteNewUser') => void;
}

const BulkUserInviteHistory = ({
  handleModal,
}: IBulkUserInviteHistoryProps) => {
  const [selectedBulkInvite, setSelectedBulkInvite] =
    useState<IGetBulkUserInvitesResData | null>(null);

  const fetchBulkUserInvites = useQuery(['get-bulk-user-invites'], () =>
    getBulkUserInvites({})
  );
  const bulkUserInvites = fetchBulkUserInvites?.data?.data;

  return (
    <>
      <div
        className={`py-2 flex items-center ${
          selectedBulkInvite && 'cursor-pointer hover:text-primaryColor-normal'
        }`}
        onClick={() => setSelectedBulkInvite(null)}
      >
        {selectedBulkInvite && <ChevronLeftIcon className='h-5 w-5' />}
        <span>Bulk User Invite History</span>
      </div>
      {!selectedBulkInvite && (
        <div>
          <table className='w-full relative flex flex-col h-80 border'>
            <thead className='bg-neutralColor-lighter'>
              <tr className='grid grid-cols-4'>
                <th>File Name</th>
                <th className='col-span-2'>Result</th>
                <th>Start Date</th>
              </tr>
            </thead>
            <tbody className='flex-1 overflow-y-auto divide-y divide-gray-300'>
              {bulkUserInvites?.map((bui: IGetBulkUserInvitesResData) => (
                <tr
                  className='grid grid-cols-4 gap-6 p-2 hover:bg-neutralColor-lightest cursor-pointer'
                  onClick={() => setSelectedBulkInvite(bui)}
                >
                  <td className='truncate'>{bui.batchName.split('_')[0]}</td>
                  <td className='col-span-2 place-self-center'>
                    <div className='flex gap-2 items-center'>
                      <CheckCircleIcon className='h-5 w-5 text-primaryColor-normal' />
                      <span>Success: {bui?.completed}</span>
                    </div>
                    <div className='flex gap-2 items-center'>
                      <XCircleIcon className='h-5 w-5 text-tertiaryColor-normal' />
                      <span>Failed: {bui?.failed}</span>
                    </div>
                  </td>
                  <td>{formatDate3(bui?.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className='flex justify-end gap-4 mt-5'>
            <Button
              label='Close'
              btnStyle='btn-primary'
              onClick={() => handleModal('inviteNewUser')}
            />
          </div>
        </div>
      )}
      {selectedBulkInvite && (
        <>
          <div className='space-y-2'>
            <p>File Name: {selectedBulkInvite.batchName.split('_')[0]}</p>
            <p>Started Date: {formatDate3(selectedBulkInvite.createdAt)}</p>
          </div>
          <BulkUserInviteSummary
            batchId={selectedBulkInvite.id}
            handleModal={handleModal}
          />
        </>
      )}
    </>
  );
};

export default BulkUserInviteHistory;
